import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RateManagerRoutingModule } from './rate-manager-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';

import { InstantRatesManagerComponent } from './pages/instant-rates-manager/instant-rates-manager.component';
import { RateListingsComponent } from './pages/rate-listings/rate-listings.component';
import { ProviderLocationsComponent } from './pages/provider-locations/provider-locations.component';
import { AppliedTermsComponent } from './pages/applied-terms/applied-terms.component';
import { ManageLocationsComponent } from './components/manage-locations/manage-locations.component';
import { ManageDepotsComponent } from './components/manage-depots/manage-depots.component';
import { ManageConfigurationsComponent } from './components/manage-configurations/manage-configurations.component';
import { SummernoteDirective } from '../../directives/summernote.directive';

@NgModule({
  declarations: [
    InstantRatesManagerComponent,
    RateListingsComponent,
    ProviderLocationsComponent,
    AppliedTermsComponent,
    SummernoteDirective,
  ],
  imports: [
    CommonModule,
    RateManagerRoutingModule,
    NgSelectModule,
    NgbModule,
    FormsModule,
    AgGridModule,
    ManageLocationsComponent,
    ManageDepotsComponent,
    ManageConfigurationsComponent,
  ],
})
export class RateManagerModule {}
